// extracted by mini-css-extract-plugin
export default {"parentContainer":"TeacherEvaluation__parentContainer___ZrpYt","container":"TeacherEvaluation__container___Y5VG9","content":"TeacherEvaluation__content___ir9bl"};